import { AjaxGetAndReplaceHtml } from "../../shared/ajaxGetAndReplaceHtml";
import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { UrlEnums } from "../../shared/utilities/enums/urlEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";

const urlPaths = require('../../config/urlPaths.json');

export interface ISearchBase extends IInstanceComponentBase {

}

export abstract class SearchBase extends InstanceComponentBase implements ISearchBase {



    constructor(htmlElement: Element) {
        super(htmlElement);
        //----- Event Listener Bindings Start -----//

        //----- Event Listener Bindings End -----//

        //----- Initialise Event Listeners Start -----//

        //----- Initialise Event Listeners End -----//
        this.initialise();
    }

    //------ Add Event Listeners Start -----//

    //------ Add Event Listeners End -----//

    //------ Remove Event Listeners Start -----//

    //------ Remove Event Listeners End -----//
    //------ Event Listener Methods Start -----//
    
   
    async initialise() {
        try{
            console.log("Search: initialise");
        let searchInputElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.Search.Input)) as HTMLInputElement;
        let value: string = searchInputElement.value;
        if(value.length > 0) {
            await this.getSearch(value);
        }
        } catch(error){
            console.log("Search: initialise Error:", error);
        }
    }


    async getSearch(searchTerm: string): Promise<void> {
        console.log("SearchBase: getSearch start");
        let searchResultsElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SearchBase.Results));
        const uriSummary = urlPaths.websiteUrl + UrlEnums.PartialUrls.Search + searchTerm;
        await AjaxGetAndReplaceHtml(searchResultsElement, uriSummary);
        console.log("SearchBase: Search end");
    }

    async getTrendingSearches(): Promise<void> {
        console.log("SearchBase: getTrendingSearches start");
        let searchResultsElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.SearchBase.Results));
        const uriSummary = urlPaths.websiteUrl + "/" + UrlEnums.PartialUrls.TrendingSearches;
        await AjaxGetAndReplaceHtml(searchResultsElement, uriSummary);
        console.log("SearchBase: getTrendingSearches end");
    }


    //------ Event Listener Methods End -----//

    dispose(): void {
        console.log('Search: dispose');
      
    }

}